import { render, staticRenderFns } from "./Component-8.vue?vue&type=template&id=1b1ae23a&scoped=true&"
import script from "./Component-8.vue?vue&type=script&lang=js&"
export * from "./Component-8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ae23a",
  null
  
)

export default component.exports